var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.027,
    height: 62.661,
    viewBox: "0 0 57.027 62.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_23",
    "data-name": "Intersection 23",
    d: "M26.3,62.661a8.788,8.788,0,0,1-8.648-8.191h-.029V49.59a14.369,14.369,0,0,0-3.491-9.283,18.884,18.884,0,1,1,28.656.124A13.974,13.974,0,0,0,39.4,49.59v4.88h-.03a8.786,8.786,0,0,1-8.647,8.191Zm.105-1.4h4.216a7.39,7.39,0,0,0,7.347-6.678H19.06A7.389,7.389,0,0,0,26.406,61.259Zm-7.379-8.192H38V50.291H19.027Zm13.719-4.218h5.275a15.355,15.355,0,0,1,3.708-9.337,17.48,17.48,0,0,0-14.056-28.9A17.727,17.727,0,0,0,11.037,27.715,17.463,17.463,0,0,0,15.2,39.4a15.828,15.828,0,0,1,3.806,9.452h5.276V28.155h-2.7a.7.7,0,0,1,0-1.4h3.078a.633.633,0,0,1,.643,0h6.417a.633.633,0,0,1,.643,0h3.078a.7.7,0,0,1,0,1.4h-2.7Zm-7.06,0h5.657V28.155H25.685Zm22-.857-4.443-4.442a.7.7,0,0,1,.992-.992L48.677,47a.7.7,0,0,1-.992.992Zm-39.334,0a.7.7,0,0,1,0-.992l4.443-4.442a.7.7,0,0,1,.992.992L9.343,47.991a.7.7,0,0,1-.992,0ZM50.045,28.53a.7.7,0,1,1,0-1.4h6.282a.7.7,0,0,1,.7.673v.058a.7.7,0,0,1-.7.673ZM.7,28.53a.7.7,0,1,1,0-1.4H6.984a.7.7,0,1,1,0,1.4ZM43.242,13.1a.7.7,0,0,1,0-.992l4.443-4.442a.7.7,0,0,1,.992.992L44.234,13.1a.7.7,0,0,1-.992,0Zm-30.448,0L8.352,8.658a.7.7,0,0,1,.992-.992l4.443,4.442a.7.7,0,0,1-.992.992ZM27.813,6.984V.7a.7.7,0,1,1,1.4,0V6.984a.7.7,0,1,1-1.4,0Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.22919dc704633d026670295382513331.svg";
export { ForwardRef as ReactComponent };